import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: "us-east-1_CUUoG0n1A",
      userPoolClientId: "2srt191ff39hofbj1o2iu0sgtb",
      loginWith: {
        email: true
      }
    }
  }
});

export const ALLOWED_USER_GROUP = "LS_CONTESTED_CASE_FORM_USERS";

// TODO: Set to false for production, true for testing purposes (so we don't have to keep logging in)
export const IS_TEST_MODE = false;